import React from 'react';

const nicknames = [
  { name: 'Churail', emoji: '🦹‍♀️', color: '#a855f7' },
  { name: 'Moti', emoji: '🌸', color: '#ff6b9d' },
  { name: 'Butterfly', emoji: '🦋', color: '#38bdf8' },
  { name: 'Pasandedah Aurat', emoji: '🦋', color: '#ffffff' },
];

export default function Footer() {
  return (
    <footer style={{
      padding: 'clamp(60px, 8vw, 100px) 24px 40px',
      background: 'linear-gradient(180deg, #100c1c 0%, #080410 100%)',
      position: 'relative', overflow: 'hidden',
      borderTop: '1px solid rgba(255,107,157,0.1)',
    }}>
      {/* Top gradient line */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: 2,
        background: 'linear-gradient(90deg, transparent, #ff6b9d, #a855f7, #38bdf8, transparent)',
      }} />

      {/* BG glow */}
      <div style={{
        position: 'absolute', bottom: -100, left: '50%', transform: 'translateX(-50%)',
        width: 600, height: 300,
        background: 'radial-gradient(ellipse, rgba(255,107,157,0.05) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        {/* Logo */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 32,
        }}>
          <div style={{
            width: 52, height: 52,
            background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
            borderRadius: '16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 24, boxShadow: '0 8px 30px rgba(255,107,157,0.3)',
            animation: 'heartbeat 2s ease-in-out infinite',
          }}>💕</div>
          <div>
            <div style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: 24,
              background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>Our Timeline</div>
            <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 13, color: '#9b7ba8' }}>
              Hassan & Fiza • Est. 2025
            </div>
          </div>
        </div>

        {/* Nicknames section */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(255,107,157,0.06), rgba(168,85,247,0.04))',
          border: '1px solid rgba(255,107,157,0.12)',
          borderRadius: 24, padding: 'clamp(24px, 4vw, 40px)', marginBottom: 40,
        }}>
          <div style={{
            fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 14,
            color: '#9b7ba8', letterSpacing: '0.12em', textTransform: 'uppercase',
            marginBottom: 8,
          }}>
            Fiza Ke Special Nicknames 💕
          </div>
          <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 13, color: '#9b7ba8', marginBottom: 28 }}>
            Names only Hassan calls her...
          </div>
          <div style={{
            display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap',
          }}>
            {nicknames.map(n => (
              <div key={n.name} style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
                padding: '20px 28px',
                background: `rgba(${n.color === '#a855f7' ? '168,85,247' : n.color === '#ff6b9d' ? '255,107,157' : '56,189,248'},0.08)`,
                border: `1px solid rgba(${n.color === '#a855f7' ? '168,85,247' : n.color === '#ff6b9d' ? '255,107,157' : '56,189,248'},0.2)`,
                borderRadius: 20,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'default',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-6px) scale(1.03)';
                e.currentTarget.style.boxShadow = `0 20px 40px rgba(${n.color === '#a855f7' ? '168,85,247' : n.color === '#ff6b9d' ? '255,107,157' : '56,189,248'},0.2)`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <div style={{
                  fontSize: 36,
                  animation: 'float 3s ease-in-out infinite',
                  animationDelay: `${nicknames.indexOf(n) * 0.5}s`,
                }}>{n.emoji}</div>
                <div style={{
                  fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 18,
                  color: n.color,
                }}>{n.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Quote */}
        <div style={{
          fontFamily: 'Nunito, sans-serif', fontSize: 15, lineHeight: 1.8,
          color: '#9b7ba8', maxWidth: 480, margin: '0 auto 32px', fontStyle: 'italic',
        }}>
          "Some stories don't have a clear beginning, middle, or end. Life is about not knowing, having to change, taking the moment and making the best of it — without knowing what's going to happen next." 💕
        </div>

        {/* Hearts */}
        <div style={{
          display: 'flex', gap: 16, justifyContent: 'center', marginBottom: 32,
        }}>
          {['💕', '🌸', '✨', '🦋', '🌙', '⭐', '💫'].map((e, i) => (
            <span key={i} style={{
              fontSize: 20, opacity: 0.6,
              animation: `float ${2.5 + i * 0.3}s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
              display: 'inline-block',
            }}>{e}</span>
          ))}
        </div>

        {/* Divider */}
        <div style={{
          width: '100%', height: 1,
          background: 'linear-gradient(90deg, transparent, rgba(255,107,157,0.2), transparent)',
          marginBottom: 24,
        }} />

        {/* Bottom */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 12,
        }}>
          <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 13, color: '#9b7ba8' }}>
            Made with 💕 by Hassan, for Fiza
          </div>
          <div style={{
            fontFamily: 'Nunito, sans-serif', fontSize: 13, color: '#9b7ba8',
            display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <span style={{ color: '#ff6b9d', animation: 'heartbeat 1.5s ease-in-out infinite', display: 'inline-block' }}>♥</span>
            Our story continues...
          </div>
        </div>
      </div>
    </footer>
  );
}